import React from "react";
import {Grid, Icon, withStyles} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CustomSelect from "../../components/Select";
import IdFilter from "../../components/Filters/IdFilter";
import {connect} from "react-redux";
import {DatePicker} from "@material-ui/pickers";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import DateFnsUtils from "@date-io/date-fns";
import ruLocale from "date-fns/locale/ru";
import {ThemeProvider} from "@material-ui/styles";
import MuiPickersUtilsProvider from "@material-ui/pickers/MuiPickersUtilsProvider";
import {IconButton} from "material-ui";
import {ArrowBack} from "@material-ui/icons";
import {format} from "date-fns";
class DateFnsTzUtils extends DateFnsUtils {
    constructor(props) {
        super();
        this.timeZone = 'Europe/Kiev';
    }
    format(date, formatString) {
        return format(date, formatString, {
            timeZone: this.timeZone,
            locale: ruLocale
        });
    }
}
const Theme = createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: '0 0',
            },
            input: {
                padding: '10.5px 14px',
            }
        },
        MuiFormLabel: {
            root: {
                lineHeight: 0
            }
        }
    },
    palette: {
        primary: {
            main: '#95c61c'
        },

        secondary: {
            main: '#95c61c',
            light: '#b2d164'
        },
    },
});

class Filters extends React.Component
{
    render() {

        const {filterBy, sites, filters, type} = this.props;
        const availSites = sites;
        return (
            <Grid container alignItems={'stretch'} direction={'row'} justify={'wrap'}>
                <Grid item xs={2} lg={2} md={2} sm={2}>
                    {type !== 'direct' &&  <Typography
                        component={'div'}
                        style={{marginBottom: '30px', fontSize: '2rem'}}
                    >
                        Статистика
                    </Typography> }
                    {type === 'direct' &&
                    <Typography component={'div'} style={{marginBottom: '30px', fontSize: '2rem'}}>
                        <Button onClick={() => this.props.setType('common')}><ArrowBack /> Назад</Button>
                    </Typography>
                    }
                        </Grid>
                {type!== 'direct' &&  <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>
                    <IdFilter onInput={(e) => {filterBy(e.target.value, 'login')}}/>
                </Grid>}
                <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>
                    <ThemeProvider theme={Theme}>
                        <MuiPickersUtilsProvider utils={DateFnsTzUtils} locale={ruLocale}>
                            <DatePicker
                                disableToolbar
                                variant="inline"
                                inputVariant={'outlined'}
                                label="Дата с:"
                                value={filters.dateFrom}
                                onChange={(val) => filterBy(val, 'dateFrom')}
                                maxDate={filters.dateTo}
                            />
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                </Grid>
                <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>
                    <ThemeProvider theme={Theme}>
                        <MuiPickersUtilsProvider utils={DateFnsTzUtils} locale={ruLocale}>
                    <DatePicker
                        disableToolbar
                        variant="inline"
                        inputVariant={'outlined'}
                        label="Дата по:"
                        value={filters.dateTo}
                        onChange={(val) => filterBy(val, 'dateTo')}
                        maxDate={new Date()}
                    />
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                </Grid>
                {type!== 'direct' &&  <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>
                    <CustomSelect
                        onChange={(val) => filterBy(val, 'site')}
                        name={'site'}
                        rowsPerPageOptions={availSites}
                        withLabel={true}
                        emptyName={'Все сайты'}
                        withEmpty
                        borderRadius={'0 0 0 0'}
                        label={'Сайт'}
                        width={'170px'}
                        value={filters.site}
                        type={'autocomplete'}
                    />
                </Grid>}

                {type!== 'direct' &&  <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>
                    <CustomSelect
                        onChange={(val) => filterBy(val, 'type')}
                        name={'type'}
                        rowsPerPageOptions={['Чат', "Письма"]}
                        withLabel={true}
                        emptyName={'Все'}
                        withEmpty
                        value={filters.type}
                        borderRadius={'0 20px 20px 0'}
                        label={'Тип'}
                        width={'170px'}
                    />
                </Grid>}
                <Grid item xs={2} lg={2} md={2} sm={2} justify={'wrap'}>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{borderRadius: '50px',marginLeft:'15px',   fontSize: '0.9rem', width: '60%', color: '#fff'}}
                        onClick={this.props.applyFiltersCallback}
                    >
                        Применить
                    </Button>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = store => {
    return {
        clients: store.Clients.clients,
        sites: store.Clients.sites
    }
}

export default connect(mapStateToProps)(Filters)